<template>
  <div>
    <div class="main-wrapper">
      <layout-header @changedLanguage="changedLanguage"></layout-header>
      <layout-navbar></layout-navbar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">

        <!-- Page Content -->
        <div class="content container-fluid">

          <div class="crms-title row bg-white">
            <div class="col  p-0">
              <h3 class="page-title m-0">
                        <span class="page-title-icon bg-gradient-primary text-white mr-2">
                          <i class="feather-grid"></i>
                        </span>{{ $t('menu.system_assessment') }}</h3>
            </div>
            <div class="col p-0 text-right">
              <ul class="breadcrumb bg-white float-right m-0 pl-0 pr-0">
                <li class="breadcrumb-item"><router-link to="/index">DSMS</router-link></li>
                <li class="breadcrumb-item active">{{ $t('menu.system_assessment') }}</li>
              </ul>
            </div>
          </div>

          <!-- Page Header -->
          <div class="page-header pt-3 mb-0 ">
            <div class="row">
              <div class="col-12 text-right">
                <ul class="list-inline-item pl-0">
                  <li class="list-inline-item">
                    <DisplayColumnsComponent :table="table" :columns="columns" v-if="table"></DisplayColumnsComponent>
                  </li>
                  <li class="list-inline-item">
                    <button class="add btn btn-gradient-primary font-weight-bold text-white todo-list-add-btn btn-rounded" id="add_system" @click.prevent="addSystemAssessment">{{ $t('new_entry') }}</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Content Starts -->
          <DataTableDSMS
            ref="dataTableDSMS"
            title="System Prüfungen"
            fileName="systemAssessment"
            modelName="system_assessment"
            deleteURL="check/v1/delete_system_assessment/"
            :extraActions="extraActions"
            :columns="columns"
            :objects="systemAssessmentList"
            :exportColumns="[0, 1, 9]"
            :allowDelete="false"
            editorPatchURL=""
            @tableCreated="setTable"
            @editorCreated="setEditor"
            @showObject="showSystemAssessment"
            @callDrawback="drawCallbackFunctions"
            v-if="systemAssessmentList.length > 0"
          ></DataTableDSMS>

          <FingerPrintSpinner v-show="!promiseFinished" color="#9b3136" :size="300" :container-padding="100" />
          <!-- /Content End -->
          <!-- /Content End -->

        </div>
        <!-- /Page Content -->

      </div>
      <!-- /Page Wrapper -->
    </diV>

    <task :currentTodo="currentTodo" origin="check_surveyaccess">
      <template v-slot:steps>
        <Steps
          :totalSteps="currentTodo.steps"
          :taskID="currentTodo.id"
          @stepsUpdated="setSteps"
        ></Steps>
      </template>
    </task>
    <Modal
      :title="$t('generate') + $t('menu.system_assessment')"
      v-if="showNewAssessmentModal"
      width="50%"
      @close ="showNewAssessmentModal = false">
      <h4 slot="header">{{ $t('generate') }} {{ $t('menu.system_assessment') }}</h4>
      <div slot="body">
        <div>
          <div class="form-group row">
            <div class="col-6">
              <label class="col-form-label">{{ $t('system') }}</label>
              <select class="form-control select select-systems" v-model="currentSystemAssessment.system" v-select2>
                <option value="">--------</option>
                <option v-for="system in systemList" :value="system.id">{{system.name}}</option>
              </select>
            </div>
            <div class="col-6">
              <label class="col-form-label">{{ $t('system') }} {{ $t('name') }}<span class="text-danger">*</span></label>
              <input class="form-control" v-model="currentSystemAssessment.name" placeholder="Name" autocomplete="off" />
              <span class="error-message text-danger" v-show="v$.currentSystemAssessment.name.$errors.length>0">{{ $t('required_field') }}</span>
            </div>
          </div> <!-- end row -->

          <div class="form-group row">
            <div class="col-6">
              <label class="col-form-label">{{ $t('copy_system_template') }}</label>
              <select class="form-control select single-select" v-model="templateSystemAssessment" v-select2>
                <option value="">--------</option>
                <option v-for="systemTemplate in templateSystemAssessmentList" :value="systemTemplate.id">{{systemTemplate.name}}</option>
              </select>
            </div>
            <div class="col-2">
              <input type="checkbox" id="gap-entry" class="form-check-input" v-model="currentSystemAssessment.gap_entry" autocomplete="off" />
              <label class="form-check-label" for="gap-entry">
                {{ $t('gap_entry') }}
              </label>
            </div>
            <div class="col-2">
              <input type="checkbox" id="todo-entry" class="form-check-input" v-model="todoEntry" autocomplete="off" />
              <label class="form-check-label" for="todo-entry">
                {{ $t('todo_entry') }}
              </label>
            </div>
            <div class="col-2">
              <input type="checkbox" id="create-system" class="form-check-input" v-model="createSystem" autocomplete="off" />
              <label class="form-check-label" for="create-system">
                {{ $t('create_system') }}
              </label>
            </div>
          </div> <!-- end row -->

          <div class="form-group row" v-show="prefillSurvey">
            <div class="col-12">
              <label class="col-form-label">Fragebogen</label>
              <select class="form-control select single-select prefill-survey-select" v-model="selectedPrefillSurveyId" v-select2>
                <option value="">--------</option>
                <option v-for="prefillItem in prefillSurveyList" :key="prefillItem.id" :value="prefillItem.id">{{ prefillItem.name }}</option>
              </select>
            </div>
          </div> <!-- end row -->

          <div class="form-group row">
            <div class="col-12">
              <label class="col-form-label">Bemerkungen</label>
              <textarea class="form-control" rows="5" v-model="currentSystemAssessment.remarks" placeholder="Bemerkungen z.B. Website, Hintergrund informationen, Link zur Datenschutzhinweisen, Produktbeschreibung" />
            </div>
          </div> <!-- end row -->

          <div class="form-group row">
            <div class="col-6">
              <div class="form-check pl-4">
                <input type="checkbox" id="prefill-survey" class="form-check-input" v-model="prefillSurvey" autocomplete="off" />
                <label class="form-check-label" for="prefill-survey">
                  Fragebogen vorausfüllen
                </label>
              </div>
            </div>
            <div class="col-6">
              <div class="form-check pl-4">
                <input type="checkbox" id="m365-assessment" class="form-check-input" v-model="isM365" autocomplete="off" />
                <label class="form-check-label" for="m365-assessment">
                  MS Office 365
                </label>
              </div>
            </div>
          </div> <!-- end row -->

          <template v-if="prefillSurvey">
            <div class="form-group row">
              <div class="col-6">
                <label class="col-form-label">AVVertrag</label>
                <input type="file" class="form-control" ref="avVertragFile" @change="handleAVVertragChange" multiple />
              </div>
              <div class="col-6">
                <label class="col-form-label">Hauptvertrag</label>
                <input type="file" class="form-control" ref="hauptvertragFile" @change="handleHauptvertragChange" multiple />
              </div>
            </div> <!-- end row -->

            <div class="form-group row">
              <div class="col-6">
                <label class="col-form-label">Andere Dokumente</label>
                <input type="file" class="form-control" ref="andereDokumenteFiles" @change="handleAndereDokumenteChange" multiple />
              </div>
              <div class="col-6">
                <label class="col-form-label">PDF Passwort</label>
                <input type="text" class="form-control" v-model="pdfPassword" placeholder="Wenn mehrere Passwörter, trenn durch ','" autocomplete="off" />
              </div>
            </div>

            <div class="form-group row">
              <div class="col-6">
                <label class="col-form-label">Home Page</label>
                <input type="url" class="form-control" v-model="homePageUrl" placeholder="https://www.example.com" autocomplete="off" />
              </div>
            </div> <!-- end row -->
          </template>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-secondary btn-sm" v-if="!prefillSurvey" @click="saveAndStartNew">Speichern und ausfüllen</button>
        <button class="btn btn-secondary btn-sm" @click="saveAndClose">Vorausfüllen und Schließen</button>
        <button class="btn btn-secondary btn-sm" @click="showNewAssessmentModal=false">schliessen</button>
      </span>
    </Modal>
    <Modal
      :title="$t('generate') + $t('ai')"
      v-if="showNewAIModal"
      width="50%"
      @close ="showNewAIModal = false">
      <h4 slot="header">{{ $t('generate') }} {{ $t('ai') }}</h4>
      <div slot="body">
        <div>
          <div class="form-group row">
            <div class="col-6">
              <label class="col-form-label">{{ $t('template') }}</label>
              <select class="form-control select single-select" v-model="templateAIResult" v-select2>
                <option value="">--------</option>
                <option v-for="aiResult in templateAIResultList" :value="aiResult.id">{{aiResult.name}}</option>
              </select>
            </div>
            <div class="col-6">
              <label class="col-form-label">{{ $t('ai') }} {{ $t('name') }}<span class="text-danger">*</span></label>
              <input class="form-control" v-model="currentAIResult.name" placeholder="Name" autocomplete="off" />
            </div>
          </div> <!-- end row -->
          <div class="form-group row">
            <div class="col-12">
              <label class="col-form-label">Bemerkungen</label>
              <textarea class="form-control" rows="5" v-model="currentAIResult.ai_remarks" placeholder="Bemerkungen z.B. Website, Hintergrund informationen, Link zur KI-Beschreibung" />
            </div>
          </div> <!-- end row -->
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-secondary btn-sm" @click="aiSaveAndStartNew">Speichern und ausfüllen</button>
        <button class="btn btn-secondary btn-sm" @click="aiSaveAndClose">Speichern und Schließen</button>
        <button class="btn btn-secondary btn-sm" @click="aiPrefillAndClose">Vorausfüllen und Schließen</button>
        <button class="btn btn-secondary btn-sm" @click="showNewAIModal=false">schliessen</button>
      </span>
    </Modal>

    <Modal
      :title="$t('generate') + ' DSFA'"
      v-if="showNewDSFAModal"
      width="50%"
      @close="showNewDSFAModal = false">
      <h4 slot="header">{{ $t('generate') }} DSFA</h4>
      <div slot="body">
        <div>
          <div class="form-group row">
            <div class="col-6">
              <label class="col-form-label">{{ $t('template') }}</label>
              <select class="form-control select single-select" v-model="templateDSFAResult" v-select2>
                <option value="">--------</option>
                <option v-for="dsfaResult in templateDSFAResultList" :key="dsfaResult.id" :value="dsfaResult.id">{{dsfaResult.name}}</option>
              </select>
            </div>
            <div class="col-6">
              <label class="col-form-label">DSFA {{ $t('name') }}<span class="text-danger">*</span></label>
              <input class="form-control" v-model="currentDSFAResult.name" placeholder="Name" autocomplete="off" />
            </div>
          </div> <!-- end row -->
          <div class="form-group row">
            <div class="col-12">
              <label class="col-form-label">Bemerkungen</label>
              <textarea class="form-control" rows="5" v-model="currentDSFAResult.dsfa_remarks" placeholder="Bemerkungen z.B. Website, Hintergrund informationen, Link zur KI-Beschreibung" />
            </div>
          </div> <!-- end row -->
          <div class="form-group row">
            <div class="col-12">
              <div class="form-check pl-4">
                <input type="checkbox" id="only-copilot" class="form-check-input" v-model="onlyCopilotSetting" autocomplete="off" />
                <label class="form-check-label" for="only-copilot">
                  Nur Copilot Einstellung prüfen
                </label>
              </div>
            </div>
          </div> <!-- end row -->
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-secondary btn-sm" @click="dsfaSaveAndStartNew">Speichern und ausfüllen</button>
        <button class="btn btn-secondary btn-sm" @click="dsfaPrefillAndClose">Vorausfüllen und Schließen</button>
        <button class="btn btn-secondary btn-sm" @click="showNewDSFAModal=false">schliessen</button>
      </span>
    </Modal>

    <CreateSystemAssessment :currentSystemAssessment="currentSystemAssessment" @showSubmitResponse="showSubmitResponse"></CreateSystemAssessment>
    <SystemAssessmentComponent :currentSystemAssessment="currentSystemAssessment" :surveyJson="currentSurveyBody" :surveyResult="currentSystemAssessment.result" :surveyType="surveyType" @surveySubmitted="showSubmitResponse" @currentSystemAssessmentSaved="updateSystemAssessmentList" @riskAnalysisFinished="closeSurveyModal"></SystemAssessmentComponent>
    <Modal
      :title="$t('generate') + $t('menu.system_assessment')"
      v-show="showAISurvey"
      width="50%"
      @close ="closeAISurvey">
      <div slot="body">
        <survey-component v-if="Object.keys(aiSurvey).length > 0" :survey-json="aiSurvey" :survey-result="currentAIResult.result" :key="aiSurveyKey" @surveyCompleted="saveAISurveyResult" @onAfterRenderPage="onSurveyAfterRenderPage" @onValueChanged="onAIValueChanged"></survey-component>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-primary btn-sm" @click="prefillCloseDSFASurvey">vorausfüllen und schliessen</button>
        <button class="btn btn-secondary btn-sm" @click="closeAISurvey">schliessen</button>
      </span>
    </Modal>
    <Modal
      :title="$t('generate') + ' DSFA'"
      v-show="showDSFASurvey"
      width="50%"
      @close ="closeDSFASurvey">
      <div slot="body">
        <survey-component v-if="Object.keys(dsfaSurvey).length > 0" :survey-json="dsfaSurvey" :survey-result="currentDSFAResult.result" :key="dsfaSurveyKey" @surveyCompleted="saveDSFASurveyResult" @onAfterRenderPage="onDSFASurveyAfterRenderPage" @onValueChanged="onDSFAValueChanged"></survey-component>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-primary btn-sm" @click="prefillCloseAISurvey">vorausfüllen und schliessen</button>
        <button class="btn btn-secondary btn-sm" @click="closeDSFASurvey">schliessen</button>
      </span>
    </Modal>
    <Modal
      :title="$t('generate') + $t('menu.system_assessment')"
      v-show="showPrefillSurveyModal"
      width="50%"
      @close="closePrefillSurvey">
      <div slot="body">
        <survey-component
          v-if="Object.keys(prefillSurveyJson).length > 0"
          :survey-json="prefillSurveyJson"
          :survey-result="currentSystemAssessment.prefill_result.result"
          :key="prefillSurveyKey"
          @surveyCompleted="savePrefillSurveyResult"
          @onAfterRenderPage="onPrefillSurveyAfterRenderPage"
          @onValueChanged="onPrefillValueChanged">
        </survey-component>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-primary btn-sm" @click="prefillCloseSurvey">vorausfüllen und schliessen</button>
        <button class="btn btn-secondary btn-sm" @click="closePrefillSurvey">schliessen</button>
      </span>
    </Modal>
  </div>
</template>
<script>
import {mapGetters, mapMutations, mapState} from 'vuex'
import service, {baseURL} from '@/utils/request.js';
import {formatDate, deepCopy, initSelect2} from '@/utils/index.js';
import { required } from '@vuelidate/validators';
import DataTableDSMS from "@/components/component/DataTableDSMS.vue";
import system from "@/components/component/SystemComponent.vue";
import {newTodo, objectModalName, newSystemAssessment, newAIResult, newDSFAResult} from "@/utils/enums";
import Steps from "@/components/component/Steps.vue";
import task from "@/components/component/TodoComponent.vue";
import comments from "@/components/component/CommentComponent.vue";
import fileUpload from "@/components/component/FileUploadComponent.vue";
import CreateSystemAssessment from "@/components/component/CreateSystemAssessment.vue";
import SystemAssessmentComponent from "@/components/component/SystemAssessmentComponent.vue";
import CommentComponent from "@/components/component/CommentComponent.vue";
import FileUploadComponent from "@/components/component/FileUploadComponent.vue";
import DisplayColumnsComponent from "@/components/component/DisplayColumnsComponent.vue";
import FingerPrintSpinner from "@/components/component/FingerPrintSpinner.vue";
import Modal from "@/components/component/Modal.vue";
import DDKModal from "@/components/component/Modal.vue";
import SurveyComponent from "@/components/component/SurveyComponent.vue";
import {useVuelidate} from "@vuelidate/core";

  export default {
    name: "SystemAssessmentListComponent",
    components: {
      SurveyComponent, DDKModal,
      Modal,
      FingerPrintSpinner,
      DisplayColumnsComponent,
      FileUploadComponent,
      CommentComponent,
      CreateSystemAssessment,
      SystemAssessmentComponent,
      task, Steps, system, DataTableDSMS, comments, fileUpload},
    data() {
      return {
        systemList: [],
        systemAssessmentList: [],
        templateSystemAssessmentList: [],
        templateAIResultList: [],
        currentSurvey: null,
        currentResult: '',
        table: null,
        editor: null,
        promiseFinished: false,
        editorPatchURL: '/check/v1/patch_system_assessment/',
        currentTodo: {},
        currentSystemAssessment: deepCopy(newSystemAssessment),
        showResponse: false,
        surveyList: {},
        currentSurveyBody: '',
        assessmentSurvey: null,
        surveyResult: null,
        gapEntry: true,
        todoEntry: true,
        createSystem: true,
        showAISurvey: false,
        aiSurvey: {},
        tempAIResult: {},
        currentAIResult: {},
        aiSurveyKey: 1,
        aiSurveySaved: false,
        showDSFASurvey: false,
        dsfaSurvey: {},
        tempDSFAResult: {},
        currentDSFAResult: {},
        dsfaSurveyKey: 1,
        dsfaSurveySaved: false,
        showPrefillSurveyModal: false,
        prefillSurveyList: [],
        selectedPrefillSurveyId: null,
        prefillSurveyJson: {},
        tempPrefillResult: {},
        prefillSurveyKey: 1,
        prefillSurveySaved: false,
        showNewAssessmentModal: false,
        showNewAIModal: false,
        showNewDSFAModal: false,
        onlyCopilotSetting: false,
        templateAIResult: null,
        templateDSFAResult: null,
        templateSystemAssessment: null,
        templateDSFAResultList: [],
        surveyType: 'dsfa',
        prefillSurvey: false,
        avVertragFile: null,
        avVertragFiles: [],
        hauptvertragFile: null,
        hauptvertragFiles: [],
        andereDokumenteFile: null,
        andereDokumenteFiles: [],
        homePageUrl: '',
        isM365: false,
        m365Survey: null,
        pdfPassword: '',
        dsfaRemarks: '',
        aiRemarks: '',
      }
    },
    validations() {
      return {
        currentSystemAssessment: {
          name: {required, $lazy: true},
        },
      }
    },
    setup() {
      return {
        v$: useVuelidate()
      }
    },
    async created() {
      await this.getSystemAssessments()
      await this.getSystemAssessmentSurvey()
      await this.getSystems()
      await this.getTemplates()
      await this.getPrefillSurveys()
    },
    watch: {
      showNewAssessmentModal(newValue) {
        if (!newValue) {
          this.prefillSurvey = false
          this.isM365 = false
          this.selectedPrefillSurveyId = null
          this.resetPrefillFiles()
        }
      },
      async isM365(newValue) {
        if (newValue) {
          if (!this.currentSystemAssessment.name) {
            this.currentSystemAssessment.name = 'Systemprüfung für MS Office 365'
          }
          const surveyData = await this.fetchM365Survey()
          if (surveyData && surveyData.id) {
            this.surveyList[surveyData.id] = typeof body === 'string' ? body : JSON.stringify(body)
          }
        }
      },
      async prefillSurvey(newValue) {
        if (!newValue)  {
          this.resetPrefillFiles()
          this.selectedPrefillSurveyId = null
        }
      },
      showAISurvey(newValue) {
        if (!newValue) {
          this.tempAIResult = {}
          this.aiSurveySaved = false
        }
      },
      showDSFASurvey(newValue) {
        if (!newValue) {
          this.tempDSFAResult = {}
          this.dsfaSurveySaved = false
        }
      },
      showPrefillSurveyModal(newValue) {
        if (!newValue) {
          this.tempPrefillResult = {}
          this.prefillSurveySaved = false
        }
      },
      onlyCopilotSetting(newValue) {
        if (newValue) {
          if (!this.currentDSFAResult.name) {
            this.currentDSFAResult.name = 'Copilot 365 Einstellung'
          }
          this.fetchDSFASurvey('Copilot 365 Einstellung')
        } else {
          this.fetchDSFASurvey('DSFA')
        }
      },
      'currentSystemAssessment.system'(newValue, oldValue) {
        if (newValue !== oldValue) {
          const systemIdx = this.systemList.findIndex(item => item.id === newValue)
          if (systemIdx !== -1) {
            this.currentSystemAssessment.name = `Systemprüfung für ${this.systemList[systemIdx].name}`
            this.createSystem = !newValue;
          }
        }
      }
    },
    computed: {
      ...mapState({accountid: state => state.account.accountid, user: state => state.user, account: state => state.account, departments: state => state.account.departments, suppliers: state => state.account.suppliers, language: state => state.app.language}),
      ...mapGetters(['selectDepartmentOptions', 'selectSupplierOptions', 'surveys']),

      columns() {
        const that = this
        return [
          {
            label: this.$t('name'),
            name: 'name',
            enableEditor: false,
            definition: { data: "name", width: "15%", render: (data, type, row, meta) => `<a class="dropdown-item edit_result" href="#" data-assessment-id="${row.id}">${data}</a>` },
          },
          {
            label: 'EMail',
            name: 'email',
            enableEditor: false,
            definition: { data: "email" },
          },
          {
            label: this.$t('ki_used'),
            name: 'ai_results',
            enableEditor: false,
            definition: {
              data: "ai_results", render: (data, type, row) => {
                let outputString = ''
                if (row.ki) {
                  if (Array.isArray(data) && data.length > 0) {
                    data.forEach(result => {
                      outputString += `<a href="#" class="related-ai-result mr-3 mb-0" data-ai-id="${result.id}" data-assessment-id="${row.id}">${result.name}</a>`
                    })
                  }
                  outputString += `<a href="#" class="new-ai-result mr-3 mb-0" data-assessment-id="${row.id}"><i class="fa fa-plus" data-assessment-id="${row.id}"></i></a>`
                } else {
                  outputString = `<span>${that.$t('not_used')}</span>`
                }
                return outputString
              }
            }
          },
          {
            label: this.$t('dsfa_required'),
            name: 'dsfa_results',
            enableEditor: false,
            definition: {
              data: "dsfa_results", render: (data, type, row) => {
                let outputString = ''
                if (row.ki) {
                  if (Array.isArray(data) && data.length > 0) {
                    data.forEach(result => {
                      outputString += `<a href="#" class="related-dsfa-result mr-3 mb-0" data-dsfa-id="${result.id}" data-assessment-id="${row.id}">${result.name}</a>`
                    })
                  }
                  outputString += `<a href="#" class="new-dsfa-result mr-3 mb-0" data-assessment-id="${row.id}"><i class="fa fa-plus" data-assessment-id="${row.id}"></i></a>`
                } else {
                  outputString = `<span>${that.$t('not_used')}</span>`
                }
                return outputString
              }
            }
          },
          {
            label: 'Token',
            name: 'token',
            enableEditor: false,
            definition: { data: "token" },
          },
          {
            label: this.$t('password'),
            name: 'password',
            enableEditor: false,
            definition: { data: "password" },
          },
          {
            label: this.$t('full_report'),
            name: 'report_url',
            enableEditor: false,
            definition: { data: "report_url", width: "4%", render: (data) => data ? `<span><a class="download-link" href="${baseURL}/survey/v1/download/?filename=${encodeURIComponent(data)}" target="_blank">Bericht</a></span>` : '' },
          },
          {
            label: this.$t('ai_report'),
            name: 'ai_report_url',
            enableEditor: false,
            definition: { data: "ai_report_url", width: "4%", render: (data) => data ? `<span><a class="download-link" href="${baseURL}/survey/v1/download/?filename=${encodeURIComponent(data)}" target="_blank">Bericht</a></span>` : '' },
          },
          {
            label: this.$t('dsfa_report'),
            name: 'dsfa_report_url',
            enableEditor: false,
            definition: { data: "dsfa_report_url", width: "4%", render: (data) => data ? `<span><a class="download-link" href="${baseURL}/survey/v1/download/?filename=${encodeURIComponent(data)}" target="_blank">Bericht</a></span>` : '' },
          },
          {
            label: this.$t('todo_list'),
            name: 'todo_list_url',
            enableEditor: false,
            definition: { data: "todo_list_url", width: "4%", render: (data) => data ? `<span><a class="download-link" href="${baseURL}/survey/v1/download/?filename=${encodeURIComponent(data)}" target="_blank">Bericht</a></span>` : '' },
          },
          {
            label: this.$t('status'),
            name: 'status',
            enableEditor: false,
            definition: { data: "status" },
          },
          {
            label: this.$t('stand'),
            name: 'modified_on',
            enableEditor: false,
            definition: { data: "modified_on", width: "5%" },
          },
        ]},
    },
    mounted() {
    },
    updated ()
    {
    },
    methods: {
      ...mapMutations({setEdit: 'SET_EDIT', setSurvey: 'SET_SURVEYS', pushSurvey: 'PUSH_SURVEYS'}),
      async closeAISurvey() {
        this.showAISurvey = false
      },
      async prefillCloseAISurvey() {
        service.request({
          url: `survey/v1/prefill_ai_result/${this.currentAIResult.id}/`,
          method: 'POST',
          responseType: 'json',
          data: {
            instance: this.currentAIResult,
            system_assessment_id: this.currentSystemAssessment.id,
            mandant: this.account.name,
            address: this.account.address,
            aufsicht: this.account.aufsichtsbehoerde
          }
        }).then((response) => {
          this.currentSystemAssessment.ai_results.push(response.data);
          const assessmentIdx = this.systemAssessmentList.findIndex(item => item.id === this.currentSystemAssessment.id)
          this.systemAssessmentList[assessmentIdx] = this.currentSystemAssessment
          this.currentAIResult = response.data
          this.table.clear().rows.add(this.systemAssessmentList).draw()
          this.$vToastify.success('KI Prüfung ist erfolgreich gestartet!')
          this.showAISurvey = false
        }).catch(function(err) {
          console.log(err)
        })
        this.showDSFASurvey = false
      },
      async prefillCloseDSFASurvey() {
        service.request({
          url: `survey/v1/prefill_dsfa_result/${this.currentAIResult.id}/`,
          method: 'POST',
          responseType: 'json',
          data: {
            instance: this.currentAIResult,
            system_assessment_id: this.currentSystemAssessment.id,
            mandant: this.account.name,
            address: this.account.address,
            aufsicht: this.account.aufsichtsbehoerde
          }
        }).then((response) => {
          this.currentSystemAssessment.ai_results.push(response.data);
          const assessmentIdx = this.systemAssessmentList.findIndex(item => item.id === this.currentSystemAssessment.id)
          this.systemAssessmentList[assessmentIdx] = this.currentSystemAssessment
          this.currentDSFAResult = response.data
          this.table.clear().rows.add(this.systemAssessmentList).draw()
          this.$vToastify.success('DSFA Vorausfüllen ist erfolgreich gestartet!')
          this.showDSFASurvey = false
        }).catch(function(err) {
          console.log(err)
        })
        this.showDSFASurvey = false
      },
      async closeDSFASurvey() {
        this.showDSFASurvey = false
      },
      onAIValueChanged(sender, options) {
        this.tempAIResult = sender.data
      },
      onDSFAValueChanged(sender, options) {
        this.tempDSFAResult = sender.data
      },
      onValueChanged(sender, options) {
        this.tempAIResult = sender.data
        this.tempDSFAResult = sender.data
      },
      onSurveyAfterRenderPage(result, options) {
        const container = options.htmlElement.parentElement.querySelector(".sd-footer");
        const button = document.createElement("button");
        button.className = "btn-lg sd-btn dkl-red";
        button.innerText = this.language === 'de' ? 'Speichern' : 'Save';
        button.onclick = () => {
          this.aiSurveySaved = true
          this.patchAISurveyResult({result: this.tempAIResult})
        };
        if (container.querySelector('.dkl-red') === null) container.appendChild(button);
      },
      onDSFASurveyAfterRenderPage(result, options) {
        const container = options.htmlElement.parentElement.querySelector(".sd-footer");
        const button = document.createElement("button");
        button.className = "btn-lg sd-btn dkl-red";
        button.innerText = this.language === 'de' ? 'Speichern' : 'Save';
        button.onclick = () => {
          this.dsfaSurveySaved = true
          this.patchDSFASurveyResult({result: this.tempDSFAResult})
        };
        if (container.querySelector('.dkl-red') === null) container.appendChild(button);
      },
      async closePrefillSurvey() {
        this.showPrefillSurveyModal = false
      },
      onPrefillValueChanged(sender, options) {
        this.tempPrefillResult = sender.data
      },
      onPrefillSurveyAfterRenderPage(result, options) {
        console.log(result)
        const container = options.htmlElement.parentElement.querySelector(".sd-footer")
        const button = document.createElement("button")
        button.className = "btn-lg sd-btn dkl-red"
        button.innerText = this.language === 'de' ? 'Speichern' : 'Save'
        button.onclick = () => {
          this.prefillSurveySaved = true
          this.patchPrefillSurveyResult({result: this.tempPrefillResult})
        }
        if (container && container.querySelector('.dkl-red') === null) {
          container.appendChild(button)
        }
      },
      async patchPrefillSurveyResult(changeObject) {
        return await service.request({
          url: `/survey/v1/patch_prefill_system_assessment/${this.currentSystemAssessment.prefill_result.id}/`,
          method: 'PUT',
          responseType: 'json',
          data: {
            ...changeObject,
          }
        }).then((response) => {
          this.$vToastify.success('Ergebnis wurde zwischengespeichert!')
          return response.data
        }).catch((err) => {
          console.log(err)
        })
      },
      async savePrefillSurveyResult(surveyResult) {
        const that = this
        this.currentSystemAssessment.modified_by = this.user.id
        return await service.request({
          url: `/survey/v1/run_prefill_system_assessment/${this.currentSystemAssessment.prefill_result.id}/`,
          method: 'POST',
          responseType: 'json',
          data: {
            fillout_on: (new Date()).toISOString().slice(0, 10),
            result: surveyResult,
            instance: this.currentSystemAssessment,
            survey_type: 'prefill'
          }
        }).then((response) => {
          const index = that.systemAssessmentList.findIndex(item => item.id === that.currentSystemAssessment.id)
          if (index !== -1) {
            that.systemAssessmentList[index] = response.data
            that.table.clear().rows.add(that.systemAssessmentList).draw()
          }
          that.$vToastify.success('Prüfung ist erfolgreich gespeichert!')
          that.showPrefillSurveyModal = false
          return response.data
        }).catch((err) => {
          console.log(err)
          that.$vToastify.error('Fehler beim Speichern der Prüfung.')
        })
      },
      async prefillCloseSurvey() {
        const that = this
        return await service.request({
          url: `/survey/v1/patch_system_assessment/${this.currentSystemAssessment.id}/`,
          method: 'PUT',
          responseType: 'json',
          data: {
            fillout_on: (new Date()).toISOString().slice(0, 10),
            result: this.tempPrefillResult || this.currentSystemAssessment.result,
            survey_type: 'prefill'
          }
        }).then((response) => {
          const index = that.systemAssessmentList.findIndex(item => item.id === that.currentSystemAssessment.id)
          if (index !== -1) {
            that.systemAssessmentList[index] = response.data
            that.table.clear().rows.add(that.systemAssessmentList).draw()
          }
          that.$vToastify.success('Vorausfüllen ist erfolgreich abgeschlossen!')
          that.showPrefillSurveyModal = false
        }).catch((err) => {
          console.log(err)
        })
      },
      async getPrefillSurveys() {
        return service.request({
          url: 'survey/v1/prefill_surveys/',
          method: 'GET',
          responseType: 'json'
        }).then((response) => {
          this.prefillSurveyList = response.data || []
          this.$nextTick(() => {
            initSelect2()
          })
          return response.data
        }).catch((err) => {
          console.log(err)
          this.$vToastify.error('Fehler beim Laden der vorausgefüllten Fragebögen.')
        })
      },
      async changedLanguage() {
        this.$nextTick(async () => {
          if (this.table) this.table.destroy();
          await this.$refs.dataTableDSMS.initTable();
        });
      },
      setTable(table) {
        this.table = table
      },
      setEditor(editor) {
        this.editor = editor
      },
      setSteps(steps) {
        this.currentTodo.steps = steps
      },
      extraActions(data) {
        return `<a class="dropdown-item delete-result" href="#" data-assessment-id="${data.id}">Prüfung löschen</a>
                <a class="dropdown-item generate-full-report" href="#" data-assessment-id="${data.id}">Prüfbericht erstellen</a>
                <a class="dropdown-item generate-ai-report" href="#" data-assessment-id="${data.id}">KI Bericht erstellen</a>
                <a class="dropdown-item generate-dsfa-report" href="#" data-assessment-id="${data.id}">DSFA Bericht erstellen</a>
                <a class="dropdown-item update-system" href="#" data-assessment-id="${data.id}">erneute Prüfung wegen Update</a>
                <a class="dropdown-item related-task" href="#" data-system-id="${data.id}">Verbundene Maßnahme</a>
                <a class="dropdown-item add-task" href="#" data-system-id="${data.id}">Maßnahme erstellen</a>`
      },
      drawCallbackFunctions() {
        const that = this
        $('.download-link').off('click').on('click', function(e) {
          e.preventDefault()
          const url = $(e.target).attr('href')
          window.open(url)
        })
        $('.related-task').off('click').on('click', function(e) {
          e.preventDefault();
          let systemID = $(e.target).data('system-id');
          that.gotoTasks(systemID)
        })
        $('.add-task').off('click').on('click', function(e) {
          e.preventDefault();
          const systemID = $(e.target).data('system-id');
          that.addTodo(systemID)
        })
        $('.delete-result').off('click').on('click', async (e) => {
          e.preventDefault()
          const checkID = $(e.target).data('assessment-id')
          that.currentSystemAssessment = that.systemAssessmentList.filter(item => item.id === parseInt(checkID))[0] || {}
          if (!that.currentSystemAssessment) that.$vToastify.error('Die System Prüfung ist nicht vorhanden.')
          if (that.currentSystemAssessment) {
            await service.request({
              url: `survey/v1/delete_system_assessment/${that.currentSystemAssessment.id}/`,
              method: 'DELETE',
              responseType: 'json'
            }).then(() => {
              // Find the index of the item with the given id
              const index = that.systemAssessmentList.findIndex(item => item.id === parseInt(checkID));

              // If the item is found, remove it from the array
              if (index !== -1) {
                that.systemAssessmentList.splice(index, 1);
                that.table.clear().rows.add(that.systemAssessmentList).draw()
              }
              that.$vToastify.success('Die System Prüfung ist erfolgreich gelöscht.');
            }).catch(function(err) {
              console.log(err)
            })
          } else {
            that.$vToastify.error('Die System Prüfung ist nicht vorhanden.')
          }
        })
        $('.change-status').off('click').on('click', async (e) => {
          e.preventDefault()
          const checkID = $(e.target).data('assessment-id')
          that.currentSystemAssessment = that.systemAssessmentList.filter(item => item.id === parseInt(checkID))[0] || {}
          if (!that.currentSystemAssessment) that.$vToastify.error('Die System Prüfung ist nicht vorhanden.')
          if (that.currentSystemAssessment) {
            await service.request({
              url: `survey/v1/patch_system_assessment/${that.currentSystemAssessment.id}/`,
              method: 'PUT',
              responseType: 'json',
              data: {status: 'released'}
            }).then((response) => {
              // Find the index of the item with the given id
              const index = that.systemAssessmentList.findIndex(item => item.id === that.currentSystemAssessment.id);

              // If the item is found, remove it from the array
              if (index !== -1) {
                that.systemAssessmentList[index] = response.data;
                that.table.clear().rows.add(that.systemAssessmentList).draw()
              }
              that.$vToastify.success('Die System Prüfung ist erfolgreich freigegeben.');
            }).catch(function(err) {
              console.log(err)
            })
          } else {
            that.$vToastify.error('Die System Prüfung ist nicht vorhanden.')
          }
        })
        $('.related-ai-result').off('click').on('click', async (e) => {
          const checkID = $(e.target).data('assessment-id')
          const aiID = $(e.target).data('ai-id')
          that.currentSystemAssessment = that.systemAssessmentList.filter(item => item.id === parseInt(checkID))[0] || {}
          if (!that.currentSystemAssessment) that.$vToastify.error('Die System Prüfung ist nicht vorhanden.')
          if (that.currentSystemAssessment) {
            that.currentAIResult = that.currentSystemAssessment.ai_results.filter(item => item.id === parseInt(aiID))[0] || {}
            that.tempAIResult = that.currentAIResult.result
            const surveyIndex = that.surveys.findIndex(item => item.id === that.currentAIResult.id)
            if (surveyIndex === -1) {
              await service.request({
                url: `survey/v1/survey/${that.currentAIResult.survey}`,
                method: 'GET',
                responseType: 'json'
              }).then((response) => {
                that.pushSurvey(response.data)
                that.aiSurvey = response.data.body
              }).catch(function(err) {
                console.log(err)
              })
            }
            that.showAISurvey = true
          } else {
            this.$vToastify.error('Die System Prüfung ist nicht vorhanden.')
          }
        })
        $('.new-ai-result').off('click').on('click', async (e) => {
          const checkID = $(e.target).data('assessment-id')
          that.currentSystemAssessment = that.systemAssessmentList.filter(item => item.id === parseInt(checkID))[0] || {}
          if (!that.currentSystemAssessment) that.$vToastify.error('Die System Prüfung ist nicht vorhanden.')
          that.currentAIResult = deepCopy(newAIResult)
          that.tempAIResult = that.currentAIResult.result
          if (that.currentSystemAssessment) {
            const surveyIndex = that.surveys.findIndex(item => item.id === that.currentAIResult.id)
            if (surveyIndex === -1) {
              await service.request({
                url: `survey/v1/survey_by_name/?name=KI Fragebogen`,
                method: 'GET',
                responseType: 'json'
              }).then((response) => {
                that.pushSurvey(response.data)
                that.aiSurvey = response.data.body
                that.currentAIResult.survey = response.data.id
              }).catch(function(err) {
                console.log(err)
              })
            }
            that.showNewAIModal = true
          } else {
            this.$vToastify.error('Die System Prüfung ist nicht vorhanden.')
          }
        })
        $('.related-dsfa-result').off('click').on('click', async (e) => {
          const checkID = $(e.target).data('assessment-id')
          const dsfaID = $(e.target).data('dsfa-id')
          that.currentSystemAssessment = that.systemAssessmentList.filter(item => item.id === parseInt(checkID))[0] || {}
          if (!that.currentSystemAssessment) {
            that.$vToastify.error('Die System Prüfung ist nicht vorhanden.')
            return
          }
          if (that.currentSystemAssessment) {
            that.currentDSFAResult = (that.currentSystemAssessment.dsfa_results || []).filter(item => item.id === parseInt(dsfaID))[0] || {}
            that.tempDSFAResult = that.currentDSFAResult.result
            await service.request({
              url: `survey/v1/survey/${that.currentDSFAResult.survey}`,
              method: 'GET',
              responseType: 'json'
            }).then((response) => {
              that.dsfaSurvey = response.data.body || response.data
            }).catch(function(err) {
              console.log(err)
            })
            that.showDSFASurvey = true
          } else {
            that.$vToastify.error('Die System Prüfung ist nicht vorhanden.')
          }
        })
        $('.new-dsfa-result').off('click').on('click', async (e) => {
          const checkID = $(e.target).data('assessment-id')
          that.currentSystemAssessment = that.systemAssessmentList.filter(item => item.id === parseInt(checkID))[0] || {}
          if (!that.currentSystemAssessment) {
            that.$vToastify.error('Die System Prüfung ist nicht vorhanden.')
            return
          }
          that.currentDSFAResult = deepCopy(newDSFAResult)
          that.tempDSFAResult = that.currentDSFAResult.result
          that.onlyCopilotSetting = false
          if (that.currentSystemAssessment) {
            await that.fetchDSFASurvey('DSFA')
            that.showNewDSFAModal = true
          } else {
            that.$vToastify.error('Die System Prüfung ist nicht vorhanden.')
          }
        })
        $('.update-system').off('click').on('click', async (e) => {
          e.preventDefault()
          const checkID = $(e.target).data('assessment-id')
          that.currentSystemAssessment = that.systemAssessmentList.filter(item => item.id === parseInt(checkID))[0] || {}
          if (!that.currentSystemAssessment) that.$vToastify.error('Die System Prüfung ist nicht vorhanden.')
          if (that.currentSystemAssessment) {
            let newAssessment = deepCopy(newSystemAssessment)
            const today = new Date()
            newAssessment.name = `Update für ${that.currentSystemAssessment.name} am ${formatDate(today, "YYYY-MM-DD")}`
            newAssessment.result = that.currentSystemAssessment.result
            newAssessment.customer = that.currentSystemAssessment.customer
            newAssessment.gap_entry = that.currentSystemAssessment.gap_entry
            newAssessment.is_upgrade = true
            newAssessment.created_by = that.user.id
            newAssessment.modified_by = that.user.id
            await service.request({
              url: 'survey/v1/create_system_assessment/',
              method: 'POST',
              responseType: 'json',
              data: {
                instance: newAssessment,
                todo: true,
              }
            }).then((response) => {
              that.systemAssessmentList.push(response.data)
              that.table.clear().rows.add(that.systemAssessmentList).draw()
              that.$confirm(
                {
                  message: `die Systemprüfung ${newAssessment.name} ist erfolgreich erstellt! Wollen Sie die editieren?`,
                  button: {
                    no: 'Nein',
                    yes: 'Ja'
                  },
                  callback: confirm => {
                    if (confirm) {
                      that.showSystemAssessment(response.data.id)
                    }
                  }
                }
              )
            }).catch(function(err) {
              console.log(err)
            })
          } else {
            that.$vToastify.error('Die System Prüfung ist nicht vorhanden.')
          }
        })
        $('.generate-full-report').off('click').on('click', async (e) => {
          e.preventDefault()
          const checkID = $(e.target).data('assessment-id')
          that.currentSystemAssessment = that.systemAssessmentList.filter(item => item.id === parseInt(checkID))[0] || {}
          if (!that.currentSystemAssessment) that.$vToastify.error('Die System Prüfung ist nicht vorhanden.')
          if (that.currentSystemAssessment) {
            await service.request({
              url: `survey/v1/generate-full-report/${that.currentSystemAssessment.id}`,
              method: 'GET',
              responseType: 'json',
            }).then((response) => {
              const assessmentIndex = that.systemAssessmentList.findIndex(item => item.id === parseInt(checkID))
              that.systemAssessmentList[assessmentIndex] = response.data
              that.table.clear().rows.add(that.systemAssessmentList).draw()
              that.$vToastify.success('Der komplette Prüfbericht ist erstellt.')
            }).catch(function(err) {
              console.log(err)
            })
          } else {
            that.$vToastify.error('Die System Prüfung ist nicht vorhanden.')
          }
        })
        $('.generate-ai-report').off('click').on('click', async (e) => {
          e.preventDefault()
          const checkID = $(e.target).data('assessment-id')
          that.currentSystemAssessment = that.systemAssessmentList.filter(item => item.id === parseInt(checkID))[0] || {}
          if (!that.currentSystemAssessment) that.$vToastify.error('Die System Prüfung ist nicht vorhanden.')
          if (that.currentSystemAssessment) {
            await service.request({
              url: `survey/v1/generate-ai-report/${that.currentSystemAssessment.id}`,
              method: 'GET',
              responseType: 'json',
            }).then((response) => {
              const assessmentIndex = that.systemAssessmentList.findIndex(item => item.id === parseInt(checkID))
              that.systemAssessmentList[assessmentIndex] = response.data.instance
              that.table.clear().rows.add(that.systemAssessmentList).draw()
              that.$vToastify.success('Der KI Prüfbericht ist erstellt.')
            }).catch(function(err) {
              console.log(err)
            })
          } else {
            that.$vToastify.error('Die System Prüfung ist nicht vorhanden.')
          }
        })
        $('.generate-dsfa-report').off('click').on('click', async (e) => {
          e.preventDefault()
          const checkID = $(e.target).data('assessment-id')
          that.currentSystemAssessment = that.systemAssessmentList.filter(item => item.id === parseInt(checkID))[0] || {}
          if (!that.currentSystemAssessment) that.$vToastify.error('Die System Prüfung ist nicht vorhanden.')
          if (that.currentSystemAssessment) {
            await service.request({
              url: `survey/v1/generate-dsfa-report/${that.currentSystemAssessment.id}`,
              method: 'GET',
              responseType: 'json',
            }).then((response) => {
              const assessmentIndex = that.systemAssessmentList.findIndex(item => item.id === parseInt(checkID))
              that.systemAssessmentList[assessmentIndex] = response.data.instance
              that.table.clear().rows.add(that.systemAssessmentList).draw()
              that.$vToastify.success('Der DSFA Prüfbericht ist erstellt.')
            }).catch(function(err) {
              console.log(err)
            })
          } else {
            that.$vToastify.error('Die System Prüfung ist nicht vorhanden.')
          }
        })
      },
      addTodo(systemAssessmentID) {
        this.currentTodo = deepCopy(newTodo)
        this.setEdit(true)
        this.currentTodo.object_id = systemAssessmentID
        this.currentTodo.model = 'check_surveyaccess'
        this.currentSystemAssessment = this.systemAssessmentList.filter(item => item.id === systemID)[0]
        $('#' + objectModalName.task).modal('show');
      },
      gotoTasks(systemID) {
        this.$router.push({name: 'massnahmenplan', params: {questionID: systemID, questionDescription: systemID.toString(), model: 'system'}})
      },
      async saveNewAssessment() {
        if (!this.currentSystemAssessment.name) {
          this.$vToastify.error('Bitte erforderliche Felder ausfüllen!')
          return false
        }
        this.currentSystemAssessment.customer = this.account.name
        this.currentSystemAssessment.created_by = this.user.id
        this.currentSystemAssessment.modified_by = this.user.id
        this.currentSystemAssessment.create_system = this.createSystem
        if (this.prefillSurvey || this.isM365) {
          this.currentSystemAssessment.is_standard = false
        } else {
          this.currentSystemAssessment.is_standard = true
        }
        if (this.isM365) {
          this.surveyType = 'prefill_ms365'
          if (!this.m365Survey) {
            await this.fetchM365Survey()
          }
          if (this.m365Survey && this.m365Survey.id) {
            this.currentSystemAssessment.survey = this.m365Survey.id
          }
        } else if (this.prefillSurvey) {
          this.surveyType = 'prefill_survey'
          if (this.selectedPrefillSurveyId) {
            this.currentSystemAssessment.survey = this.selectedPrefillSurveyId
          }
        } else if (!this.currentSystemAssessment.survey && this.assessmentSurvey && this.assessmentSurvey.id) {
          this.currentSystemAssessment.survey = this.assessmentSurvey.id
        }
        const useTemplate = Boolean(this.templateSystemAssessment)
        const payload = {
          instance: this.currentSystemAssessment,
          todo: this.todoEntry,
          useTemplate: useTemplate,
          templateID: this.templateSystemAssessment
        }
        if (this.isM365) {
          payload.survey_type = 'prefill_ms365'
        } else if (this.prefillSurvey) {
          payload.survey_type = 'prefill_survey'
        }
        return service.request({
          url: 'survey/v1/create_system_assessment/',
          method: 'POST',
          responseType: 'json',
          data: payload
        }).then((response) => {
          this.systemAssessmentList.push(response.data);
          this.currentSystemAssessment = response.data
          this.table.clear().rows.add(this.systemAssessmentList).draw()
          this.$vToastify.success('System Prüfung ist erfolgreich gespeichert!')
          return true
        }).catch(function(err) {
          console.log(err)
          return false
        })
      },
      async automateSystemAssessment() {
        if (!this.currentSystemAssessment.name) {
          this.$vToastify.error('Bitte erforderliche Felder ausfüllen!');
          return false;
        }
        this.currentSystemAssessment.customer = this.account.name;
        this.currentSystemAssessment.created_by = this.user.id;
        this.currentSystemAssessment.modified_by = this.user.id;
        this.currentSystemAssessment.create_system = this.createSystem;
        if (this.prefillSurvey || this.isM365) {
          this.currentSystemAssessment.is_standard = false;
        } else {
          this.currentSystemAssessment.is_standard = true;
        }
        if (this.prefillSurvey) {
          this.surveyType = 'prefill_survey';
        } else if (this.isM365) {
          this.surveyType = 'prefill_ms365';
        }
        if (!this.currentSystemAssessment.survey && this.assessmentSurvey && this.assessmentSurvey.id) {
          this.currentSystemAssessment.survey = this.assessmentSurvey.id;
        }
        const useTemplate = Boolean(this.templateSystemAssessment);

        const formData = new FormData();
        this.currentSystemAssessment.status = 'In Bearbeitung';
        formData.append('instance', JSON.stringify(this.currentSystemAssessment));
        formData.append('todo', this.todoEntry);
        formData.append('useTemplate', useTemplate);
        if (this.templateSystemAssessment) {
          formData.append('templateID', this.templateSystemAssessment);
        }
        formData.append('survey_type', this.surveyType);
        formData.append('home_page', this.homePageUrl);
        formData.append('prefill_survey', true);
        formData.append('pdf_passwords', this.pdfPassword);
        formData.append('selected_prefillsurvey_id', this.selectedPrefillSurveyId);

        // Uploaded files
        if (this.avVertragFiles && this.avVertragFiles.length > 0) {
          this.avVertragFiles.forEach(file => {
            formData.append('av_vertrag', file);
          });
        } else if (this.avVertragFile) {
          formData.append('av_vertrag', this.avVertragFile);
        }

        if (this.hauptvertragFiles && this.hauptvertragFiles.length > 0) {
          this.hauptvertragFiles.forEach(file => {
            formData.append('hauptvertrag', file);
          });
        } else if (this.hauptvertragFile) {
          formData.append('hauptvertrag', this.hauptvertragFile);
        }

        if (this.andereDokumenteFiles && this.andereDokumenteFiles.length > 0) {
          this.andereDokumenteFiles.forEach(file => {
            formData.append('other_documents', file);
          });
        } else if (this.andereDokumenteFile) {
          formData.append('other_documents', this.andereDokumenteFile);
        }

        return service.request({
          url: 'survey/v1/automate_system_assessment/',
          method: 'POST',
          data: formData,
          headers: { 'Content-Type': 'multipart/form-data' }
        }).then((response) => {
          if (response && response.data) {
            this.systemAssessmentList.push(response.data);
            this.currentSystemAssessment = response.data;
            if (this.table) {
              this.table.clear().rows.add(this.systemAssessmentList).draw();
            }
          }
          this.$vToastify.success('System Prüfung ist erfolgreich gespeichert!');
          return true;
        }).catch((err) => {
          console.log(err);
          this.$vToastify.error('Fehler beim Speichern der Systemprüfung.');
          return false;
        });
      },
      async fetchM365Survey() {
        if (this.m365Survey) {
          return this.m365Survey;
        }
        return service.request({
          url: `survey/v1/survey_by_name/?name=${encodeURIComponent('Microsoft 365 – Systemprüfung')}`,
          method: 'GET',
          responseType: 'json'
        }).then((response) => {
          this.m365Survey = response.data;
          return response.data;
        }).catch(async (err) => {
          return service.request({
            url: `survey/v1/survey_by_name/?name=${encodeURIComponent('Microsoft 365 - Systemprüfung')}`,
            method: 'GET',
            responseType: 'json'
          }).then((response) => {
            this.m365Survey = response.data;
            return response.data;
          }).catch((err2) => {
            console.log(err2);
            return null;
          });
        });
      },
      async saveNewAIResult(prefill=false) {
        this.currentAIResult.system_assessment = [this.currentSystemAssessment.id]
        this.currentAIResult.created_by = this.user.id
        this.currentAIResult.modified_by = this.user.id
        const copyTemplate = Boolean(this.templateAIResult)
        service.request({
          url: 'survey/v1/create_ai_result/',
          method: 'POST',
          responseType: 'json',
          data: {
            instance: this.currentAIResult,
            copyTemplate: copyTemplate,
            templateAIResult: this.templateAIResult,
            prefill: prefill,
            mandant: this.account.name,
            address: this.account.address,
            aufsicht: this.account.aufsichtsbehoerde
          }
        }).then((response) => {
          this.currentSystemAssessment.ai_results.push(response.data);
          const assessmentIdx = this.systemAssessmentList.findIndex(item => item.id === this.currentSystemAssessment.id)
          this.systemAssessmentList[assessmentIdx] = this.currentSystemAssessment
          this.currentAIResult = response.data
          this.table.clear().rows.add(this.systemAssessmentList).draw()
          this.$vToastify.success('KI Prüfung ist erfolgreich gespeichert!')
        }).catch(function(err) {
          console.log(err)
        })
      },
      async aiPrefillAndClose() {
        await this.saveNewAIResult(true)
        this.showNewAIModal = false
      },
      async aiSaveAndClose() {
        await this.saveNewAIResult()
        this.showNewAIModal = false
      },
      async aiSaveAndStartNew() {
        await this.saveNewAIResult()
        this.showNewAIModal = false
        this.showAISurvey = true
      },
      async saveAndStartNew() {
        await this.saveAndClose();
        if (this.currentSystemAssessment && this.currentSystemAssessment.id) {
          await this.showSystemAssessment(this.currentSystemAssessment.id)
        }
      },
      async saveAndClose() {
        if (this.prefillSurvey) {
          const success = await this.automateSystemAssessment();
          if (success) {
            this.showNewAssessmentModal = false;
            const prefillSurveyId = this.currentSystemAssessment.prefill_result.survey;
            if (prefillSurveyId) {
              const selectedPrefillSurvey = this.prefillSurveyList.filter(item => item.id === prefillSurveyId)[0];
              this.prefillSurveyJson = selectedPrefillSurvey.body;
              this.showPrefillSurveyModal = true;
            }
          }
        } else {
          const success = await this.saveNewAssessment();
          if (success) {
            this.showNewAssessmentModal = false;
          }
        }
      },
      addSystemAssessment() {
        this.currentSystemAssessment = deepCopy(newSystemAssessment)
        this.currentSystemAssessment.customer = this.account.name
        this.currentSystemAssessment.survey = this.assessmentSurvey ? this.assessmentSurvey.id : 9
        this.currentSystemAssessment.modified_by = this.user.id
        this.prefillSurvey = false
        this.isM365 = false
        this.resetPrefillFiles()
        if (this.assessmentSurvey && this.assessmentSurvey.id && this.surveyList[this.assessmentSurvey.id]) {
          this.currentSurveyBody = this.surveyList[this.assessmentSurvey.id]
        }
        this.showNewAssessmentModal = true
      },
      handleAVVertragChange(event) {
        const files = event.target.files ? Array.from(event.target.files) : []
        this.avVertragFiles = files
        this.avVertragFile = files[0] || null
      },
      handleHauptvertragChange(event) {
        const files = event.target.files ? Array.from(event.target.files) : []
        this.hauptvertragFiles = files
        this.hauptvertragFile = files[0] || null
      },
      handleAndereDokumenteChange(event) {
        const files = event.target.files ? Array.from(event.target.files) : []
        this.andereDokumenteFiles = files
        this.andereDokumenteFile = files[0] || null
      },
      resetPrefillFiles() {
        this.selectedPrefillSurveyId = null
        this.avVertragFile = null
        this.avVertragFiles = []
        this.hauptvertragFile = null
        this.hauptvertragFiles = []
        this.andereDokumenteFile = null
        this.andereDokumenteFiles = []
        this.homePageUrl = ''
        if (this.$refs.avVertragFile) this.$refs.avVertragFile.value = ''
        if (this.$refs.hauptvertragFile) this.$refs.hauptvertragFile.value = ''
        if (this.$refs.andereDokumenteFiles) this.$refs.andereDokumenteFiles.value = ''
      },
      async showSystemAssessment(showSystemAssessmentID) {
        if (showSystemAssessmentID) this.currentSystemAssessment = this.systemAssessmentList.filter(item => item.id === showSystemAssessmentID)[0] || {}
        if (!this.currentSystemAssessment.evaluation) this.currentSystemAssessment.evaluation = this.$t('dpo_assessment_template')
        if (this.currentSystemAssessment) {
          if (!(this.currentSystemAssessment.survey in this.surveyList)) {
            await service.request({
              url: `survey/v1/survey/${this.currentSystemAssessment.survey}/`,
              method: 'GET',
              responseType: 'json'
            }).then((response) => {
              this.surveyList[this.currentSystemAssessment.survey] = JSON.stringify(response.data.body);
            }).catch(function(err) {
              console.log(err)
            })
          }
          this.currentSurveyBody = this.surveyList[this.currentSystemAssessment.survey]
          $('#' + objectModalName.system_assessment).modal('show');
        } else {
          this.$vToastify.error('Die System Prüfung ist nicht vorhanden.')
        }
      },
      async patchAISurveyResult(changeObject) {
        return await service.request({
          url: `/survey/v1/patch_ai_result/${this.currentAIResult.id}/`,
          method: 'PUT',
          responseType: 'json',
          data: changeObject
        }).then(function(response) {
          console.log('Ergebnis wurde hochgeladen!')
          return response.data
        }).catch(function(err) {
          console.log(err)
        })
      },
      async saveAISurveyResult(surveyResult) {
        const that = this
        let responseData = null
        this.currentAIResult.result = surveyResult
        this.currentAIResult.modified_by = this.user.id
        const method = this.currentAIResult.id ? 'create' : 'update'
        if (method === 'create') this.currentAIResult.created_by = this.user.id
        const url = this.currentAIResult.id ? `/survey/v1/update_ai_result/${this.currentAIResult.id}/` : `/survey/v1/create_ai_result/`
        responseData = await service.request({
          url: url,
          method: 'POST',
          responseType: 'json',
          data: this.currentAIResult
        }).then(function(response) {
          if (method === 'create') that.currentSystemAssessment.ai_results.push(response.data)
          else {
            const resultIndex = that.currentSystemAssessment.ai_results.findIndex(item => item.id === response.data.id)
            that.currentSystemAssessment.ai_results[resultIndex] = response.data
          }
          that.table.clear().rows.add(this.systemAssessmentList).draw()
          console.log('Ergebnis wurde hochgeladen!')
          return response.data
        }).catch(function(err) {
          console.log(err)
        })

        return responseData
      },
      async saveNewDSFAResult(prefill=false) {
        this.surveyType = this.onlyCopilotSetting ? 'copilot' : 'dsfa'
        this.currentDSFAResult.system_assessment = this.currentSystemAssessment.id
        this.currentDSFAResult.created_by = this.user.id
        this.currentDSFAResult.modified_by = this.user.id
        const copyTemplate = Boolean(this.templateDSFAResult)
        return service.request({
          url: 'survey/v1/create_dsfa_result/',
          method: 'POST',
          responseType: 'json',
          timeout: 180000,
          data: {
            instance: this.currentDSFAResult,
            copyTemplate: copyTemplate,
            templateDSFAResult: this.templateDSFAResult,
            dsfaRemarks: this.dsfaRemarks,
            prefill: prefill,
            mandant: this.account.name,
            address: this.account.address,
            aufsicht: this.account.aufsichtsbehoerde
          }
        }).then((response) => {
          if (!this.currentSystemAssessment.dsfa_results) {
            this.$set(this.currentSystemAssessment, 'dsfa_results', [])
          }
          this.currentSystemAssessment.dsfa_results.push(response.data);
          const assessmentIdx = this.systemAssessmentList.findIndex(item => item.id === this.currentSystemAssessment.id)
          if (assessmentIdx !== -1) {
            this.systemAssessmentList[assessmentIdx] = this.currentSystemAssessment
          }
          this.currentDSFAResult = response.data
          this.table.clear().rows.add(this.systemAssessmentList).draw()
          this.$vToastify.success('DSFA Prüfung ist erfolgreich gespeichert!')
        }).catch(function(err) {
          console.log(err)
        })
      },
      async dsfaPrefillAndClose() {
        await this.saveNewDSFAResult(true)
        this.showNewDSFAModal = false
      },
      async dsfaSaveAndStartNew() {
        await this.saveNewDSFAResult()
        this.showNewDSFAModal = false
        this.showDSFASurvey = true
      },
      async patchDSFASurveyResult(changeObject) {
        return await service.request({
          url: `/survey/v1/patch_dsfa_result/${this.currentDSFAResult.id}/`,
          method: 'PUT',
          responseType: 'json',
          data: changeObject
        }).then(function(response) {
          console.log('Ergebnis wurde hochgeladen!')
          return response.data
        }).catch(function(err) {
          console.log(err)
        })
      },
      async saveDSFASurveyResult(surveyResult) {
        const that = this
        let responseData = null
        this.currentDSFAResult.result = surveyResult
        this.currentDSFAResult.modified_by = this.user.id
        const isNew = !this.currentDSFAResult.id
        if (isNew) this.currentDSFAResult.created_by = this.user.id
        const url = this.currentDSFAResult.id ? `/survey/v1/update_dsfa_result/${this.currentDSFAResult.id}/` : `/survey/v1/create_dsfa_result/`
        responseData = await service.request({
          url: url,
          method: 'POST',
          responseType: 'json',
          data: this.currentDSFAResult
        }).then(function(response) {
          if (!that.currentSystemAssessment.dsfa_results) {
            that.$set(that.currentSystemAssessment, 'dsfa_results', [])
          }
          if (isNew) {
            that.currentSystemAssessment.dsfa_results.push(response.data)
          } else {
            const resultIndex = that.currentSystemAssessment.dsfa_results.findIndex(item => item.id === response.data.id)
            if (resultIndex !== -1) {
              that.currentSystemAssessment.dsfa_results[resultIndex] = response.data
            }
          }
          that.table.clear().rows.add(this.systemAssessmentList).draw()
          console.log('Ergebnis wurde hochgeladen!')
          return response.data
        }).catch(function(err) {
          console.log(err)
        })

        return responseData
      },
      saveCurrentAssessmentAISurvey(assessment) {
        this.currentSystemAssessment = assessment
        const assessmentIndex = this.systemAssessmentList.findIndex(item => item.id === assessment.id)
        this.systemAssessmentList[assessmentIndex] = assessment
      },
      toggle_column(event, column_index) {
        // Get the column API object
        let column = $('.datatable').DataTable().column(column_index);

        // Toggle the visibility
        column.visible(!column.visible());

        // adjust dropdown menu
        if (column.visible() && !$(event.target).hasClass('selected')) {
          $(event.target).addClass('selected')
        } else if (!column.visible() && $(event.target).hasClass('selected')) {
          $(event.target).removeClass('selected');
        }
      },
      closeSurveyModal() {
        $('#' + objectModalName.system_assessment).modal('hide')
      },
      showSubmitResponse(assessmentObject) {
        this.showResponse = true
        const assessmentID = this.systemAssessmentList.findIndex(assessment => assessment.id === assessmentObject.id)
        if (assessmentID === -1) {
          this.systemAssessmentList.push(assessmentObject)
        } else {
          this.systemAssessmentList[assessmentID] = assessmentObject
        }
        this.table.clear().rows.add(this.systemAssessmentList).draw()
        this.$vToastify.success('System Prüfung ist erfolgreich gespeichert!')
        $('#' + objectModalName.system_assessment).modal('hide')
        $('#' + objectModalName.new_system_assessment).modal('hide')
      },
      updateSystemAssessmentList(systemAssessment) {
        const assessmentID = this.systemAssessmentList.findIndex(assessment => assessment.id === systemAssessment.id)
        if (assessmentID !== -1) {
          this.systemAssessmentList[assessmentID] = systemAssessment
        }
      },
      async getSurveyList() {
        const surveys = this.systemAssessmentList.map(item => item.survey)
        const uniqueSurveys = [...new Set(surveys)]
        uniqueSurveys.forEach(surveyID => {
          service.request({
            url: `survey/v1/survey/${surveyID}/`,
            method: 'GET',
            responseType: 'json'
          }).then((response) => {
            this.surveyList[surveyID] = JSON.stringify(response.data.body);
          }).catch(function(err) {
            console.log(err)
          })
        })
      },
      async getSystemAssessmentSurvey() {
        service.request({
          url: `survey/v1/survey_by_name/?name=system_assessment`,
          method: 'GET',
          responseType: 'json'
        }).then((response) => {
          this.assessmentSurvey = response.data
        }).catch(function(err) {
          console.log(err)
        })
      },
      async fetchDSFASurvey(surveyName = 'DSFA') {
        const targetName = this.onlyCopilotSetting ? 'Copilot 365 Einstellung' : surveyName;
        return service.request({
          url: `survey/v1/survey_by_name/?name=${encodeURIComponent(targetName)}`,
          method: 'GET',
          responseType: 'json'
        }).then((response) => {
          this.dsfaSurvey = response.data.body || response.data
          if (this.currentDSFAResult) {
            this.currentDSFAResult.survey = response.data.id
          }
          return response.data
        }).catch(function(err) {
          console.log(err)
        })
      },
      async getDSFASurvey() {
        await this.fetchDSFASurvey('DSFA')
      },
      async getSystemAssessments() {
        const that = this
        service.request({
          url: `survey/v1/system_assessment/${this.accountid}/`,
          method: 'GET',
          responseType: 'json'
        }).then(async function(response) {
          that.systemAssessmentList = response.data;
          await that.getSurveyList()
          that.promiseFinished = true
        }).catch(function(err) {
          console.log(err)
          that.promiseFinished = true
        })
      },
      async getSystems() {
        const that = this
        service.request({
          url: `todos/v1/system/${this.accountid}/`,
          method: 'GET',
          responseType: 'json'
        }).then(function(response) {
          that.systemList = response.data;
        }).catch(function(err) {
          console.log(err)
        })
      },
      async getTemplates() {
        const that = this
        service.request({
          url: `survey/v1/template_system_assessments/`,
          method: 'GET',
          responseType: 'json'
        }).then(function(response) {
          that.templateSystemAssessmentList = response.data;
        }).catch(function(err) {
          console.log(err)
        })
        service.request({
          url: `survey/v1/template_ai_results/`,
          method: 'GET',
          responseType: 'json'
        }).then(function(response) {
          that.templateAIResultList = response.data;
        }).catch(function(err) {
          console.log(err)
        })
        service.request({
          url: `survey/v1/template_dsfa_results/`,
          method: 'GET',
          responseType: 'json'
        }).then(function(response) {
          that.templateDSFAResultList = response.data;
        }).catch(function(err) {
          console.log(err)
        })
      }
    }
  }
</script>
<style scoped>
ol {
  list-style: upper-latin;
  margin-left: 2rem;
}
</style>
